document.addEventListener('DOMContentLoaded', function() {
  // Find ALL links that have the href "#scroll-to-cart"
  const ctaLinks = document.querySelectorAll('a[href="#scroll-to-cart"]');
  const addToCartButton = document.getElementById('add-to-cart-target');

  if (ctaLinks.length > 0 && addToCartButton) {
    ctaLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();

        const header = document.querySelector('.shopify-section-header');
        const headerHeight = header ? header.offsetHeight : 0;
        const elementPosition = addToCartButton.getBoundingClientRect().top + window.scrollY;
        const offset = 20;
        const offsetPosition = elementPosition - headerHeight - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    });
  }
});